"use strict";
export const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
export const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];
export const getDates = (year, month) => {
  const numberOfDays = new Date(year, month + 1, 0).getDate();
  const today = new Date().toISOString().split("T")[0];
  const dates = [];
  for (let dayOfMonth = 1; dayOfMonth <= numberOfDays; dayOfMonth++) {
    const dayOfWeek = (new Date(year, month, dayOfMonth).getDay() + 6) % 7;
    const date = new Date(year, month, dayOfMonth + 1).toISOString().split("T")[0];
    dates.push({
      day: dayOfWeek,
      date: dayOfMonth,
      month,
      year,
      present: today == date ? 0 : today > date ? -1 : 1
    });
  }
  return {
    name: months[month],
    dates,
    year
  };
};
export const getIsoDate = (date) => {
  return new Date(date.year, date.month, date.date).toISOString().split("T")[0];
};
